"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyCodes_1 = require("./KeyCodes");
var dom_1 = require("./dom");
// Default to undefined so that we initialize on first read.
var _isRTL;
/**
 * Gets the rtl state of the page (returns true if in rtl.)
 */
function getRTL() {
    var isRTL = _isRTL;
    if (isRTL === undefined) {
        var doc = dom_1.getDocument();
        if (doc && doc.documentElement) {
            isRTL = doc.documentElement.getAttribute('dir') === 'rtl';
        }
    }
    return isRTL;
}
exports.getRTL = getRTL;
/**
 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
 */
function setRTL(isRTL) {
    var doc = dom_1.getDocument();
    if (doc && doc.documentElement) {
        doc.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    }
    _isRTL = isRTL;
}
exports.setRTL = setRTL;
/**
 * Returns the given key, but flips right/left arrows if necessary.
 */
function getRTLSafeKeyCode(key) {
    if (getRTL()) {
        if (key === KeyCodes_1.KeyCodes.left) {
            key = KeyCodes_1.KeyCodes.right;
        }
        else if (key === KeyCodes_1.KeyCodes.right) {
            key = KeyCodes_1.KeyCodes.left;
        }
    }
    return key;
}
exports.getRTLSafeKeyCode = getRTLSafeKeyCode;

//# sourceMappingURL=rtl.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib/rtl.js
// module id = 157
// module chunks = 0